import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FinanceArrayModel, FinanceModel } from "../../models/FinanceModel";

const initialFinanceState: FinanceArrayModel = {
  all_Finances: [],
  particular_Finance: {
    fundingSourceId: 0,
    name: "",
    description: "",
    isActive: false,
  },
  isFinancesFetching: false,
};
const FinanceSlice = createSlice({
  name: "Finance",
  initialState: initialFinanceState,
  reducers: {
    setFinances(state, action: PayloadAction<FinanceModel[]>) {
      state.all_Finances = action.payload;
    },
    setParticularFinance(state, action: PayloadAction<FinanceModel>) {
      state.particular_Finance = action.payload;
    },
    setIsFinancesFetching(state, action: PayloadAction<boolean>) {
      state.isFinancesFetching = action.payload;
    },
  },
});
export default FinanceSlice;
